<template>
	<div>
		<el-card class="box-card">
			<div slot="header" class="flex-be">
				<div class="search_condition">
					<div>
						<el-date-picker
							class="m-r-10"
							size="small"
							v-model="dateTime"
							type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							@change="changeTime"
							clearable
						>
						</el-date-picker>

						<!-- <el-select size="small" v-model="status" placeholder="请选择" class="search_condition_item"
					@change="getDataFn">
					<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select> -->
						<el-button size="small" type="primary" @click="searchFunc">搜索</el-button>
					</div>
					<div>
						<el-button size="small" type="danger" @click="batchDeletionFn">批量删除</el-button>
						<el-button size="small" type="primary" @click="batchDownLoad">批量下载</el-button>
						<el-button size="small" type="primary" @click="batchAllDownLoad">下载全部数据</el-button>
					</div>
				</div>
			</div>
			<div class="content_table">
				<el-table
					:data="configTable.tableData"
					:loading="configTable.loading"
					@handleClick="handleClick"
					@selection-change="handleSelectionChangeFn"
					@handleSelectionChange="handleSelectionChangeFn"
				>
					<el-table-column type="selection" width="55"> </el-table-column>
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column prop="dataInfoName" label="数据信息名称" width="450" align="left"></el-table-column>
					<el-table-column prop="taskName" label="任务名称" align="center"> </el-table-column>
					<el-table-column prop="dataLevelName" label="数据级别名称" align="center"></el-table-column>
					<el-table-column prop="loadName" label="有效载荷" align="center"></el-table-column>
					<el-table-column prop="createTime" label="收藏时间" align="center"></el-table-column>
				</el-table>
				<el-empty v-if="configTable.tableData.length <= 0" description="暂无数据"></el-empty>
			</div>
			<div class="flex-be m-t-20">
				<!-- <el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button> -->
				<el-pagination
					@current-change="getDataFn"
					@size-change="handleSizeChange"
					:current-page.sync="configTable.current"
					layout="total, sizes, prev, pager, next, jumper"
					background
					:page-sizes="[10, 15, 20, 100]"
					:page-size="configTable.pageSize"
					:total="configTable.total"
				></el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
import axios from 'axios'
import tableTotal from '@/components/TableTotal/TableTotal'

export default {
	name: 'favoritesList',
	// import引入的组件需要注入到对象中才能使用
	components: {
		tableTotal
	},
	filters: {
		filter(value) {
			if (!value) {
				return '-'
			}
			if (!value.goodsSpec) {
				return '-'
			}
			if (value.goodsSpec[0] === '{') {
				let str = value.goodsSpec.slice(1, value.goodsSpec.length - 1)
				return str.replace(/,/g, ',').replace(/"/g, '').replace(/:/g, ' : ')
			}
		}
	},
	data() {
		// 这里存放数据
		return {
			dateTime: '',
			status: 0,
			statusList: [
				{ value: 0, label: '全部状态' },
				{ value: 1, label: '上架' },
				{ value: 2, label: '下架' }
			],
			// 配置表格
			configTable: {
				loading: false,
				indexShow: false,
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			},
			tableSelect: []
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	mounted() {
		this.info()
	},
	// 方法集合
	methods: {
		info() {
			// 获取数据
			this.getDataFn()
		},
		changeTime() {
			this.configTable.current = 1
			this.getDataFn()
		},
		batchDelete() {
			console.log(this.tableSelect)
		},
		searchFunc() {
			this.getDataFn()
		},
		async batchAllDownLoad() {
			// this.tableSelect = this.configTable.tableData
			let params = {
				beginTime: this.dateTime ? this.dateTime[0] : '',
				endTime: this.dateTime ? this.dateTime[1] : '',
				pageNum: 1,
				pageSize: 100000
			}
			let res = await this.$http.get(this.$const.personalCenter.getUserList, params)
			if (res && res.rows) {
				this.tableSelect = res.rows
			}
			this.batchDownLoad()
		},
		async batchDownLoad() {
			if (this.tableSelect.length <= 0) {
				this.$message.warning(this.$PubText.multipleTip)
				return
			}
			console.log(this.tableSelect)
			const ids = this.tableSelect.map((item) => {
				return item.id
			})
			let p = {
				collectId: ids.toString()
			}
			console.log(ids)
			// let res = await this.$http.post(this.$const.personalCenter.batchDownloadApi, ids)
			// if (res && res) {
			// 	console.log(res)
			// }

			const authorizationVal = this.$cookie.get('PIE_MALL_Token')
			// this.headers = { Authorization: this.authorization }
			// 基础 POST 下载
			axios({
				method: 'post',
				url: `${window.dataManage.devPrefix}/client/science/bookmark/download`,
				data: ids,
				headers: {
					Authorization: `Bearer ${authorizationVal}`
				}
				// responseType: 'blob' // 重要：指定响应类型为 blob
			})
				.then((response) => {
					this.$message.success('下载成功！')
					window.open(response.data.data, '_blank')
					// 创建 blob 对象
					// const blob = new Blob([response.data], { type: 'text/plain' })
					// console.log(response.data)
					// // 创建下载链接
					// const url = window.URL.createObjectURL(blob)
					// const link = document.createElement('a')
					// link.href = url
					// link.download = 'bookmarkDownloadResult.txt' // 设置下载文件名
					// document.body.appendChild(link)
					// link.click()
					// // 清理
					// document.body.removeChild(link)
					// window.URL.revokeObjectURL(url)
				})
				.catch((error) => {
					console.error('下载失败:', error)
				})
		},
		async getDataFn() {
			let params = {
				beginTime: this.dateTime ? this.dateTime[0] : '',
				endTime: this.dateTime ? this.dateTime[1] : '',
				pageNum: this.configTable.current,
				pageSize: this.configTable.pageSize
			}
			try {
				this.configTable.loading = true
				let res = await this.$http.get(this.$const.personalCenter.getUserList, params)
				if (res && res.rows) {
					console.log(res)
					this.configTable.tableData = res.rows
					this.configTable.total = res.total
					this.configTable.loading = false
				}
			} catch (e) {
				this.configTable.loading = false
				// console.log(e);
			}
		},
		async handleClick(event, data, text) {
			switch (event) {
				case 'seeData':
					this.$router.push({ name: 'productDetail', params: { id: data.goodId } })
					break
				case 'delete':
					this.$confirm(text, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						let p = {
							collectId: data.id
						}
						await this.collectDeleteFn(p)
					})
					break
			}
		},
		async collectDeleteFn(data) {
			try {
				let res = await this.$http.delete(this.$const.personalCenter.batchDeleteApi, data)
				if (res && res.code === 200) {
					// console.log(res);
					this.$message.success(this.$PubText.successCom)
					this.getDataFn()
				}
			} catch (e) {
				// console.log(e);
			}
		},
		handleSizeChange(val) {
			this.configTable.pageSize = val
			this.getDataFn()
		},
		// 表格多选 全选
		handleSelectionChangeFn(data) {
			this.tableSelect = data
			console.log(this.tableSelect)
		},
		batchDeletionFn() {
			if (this.tableSelect.length <= 0) {
				this.$message.warning(this.$PubText.multipleTip)
				return
			}
			this.$confirm('删除数据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const ids = this.tableSelect.map((item) => {
					return item.id
				})
				let p = {
					collectId: ids.toString()
				}
				await this.collectDeleteFn(ids)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.search_condition_item {
	width: 140px;
}
.search_condition {
	display: flex;
	justify-content: space-between;
	width: 100%;
}
.pagination_box {
	text-align: right;
}
</style>
